import { useEffect, useRef, useState } from 'react';
import { useTotal } from '../../../selectors';
import { useGlobalStore } from '../../../store';
import {
  priceTotalStyles,
  containerStyles,
  currencyStyles,
  estimatedCostStyles,
  iconStyles,
  totalStyles,
  wrapperStyles
} from './price-total-mobile.styles';
import { useModuleProps } from '../../../module-props';
export interface PriceTotalMobileProps {
  pricingDisplayRef: React.RefObject<HTMLDivElement>;
  isCurrency?: boolean;
}

const PriceTotalMobile = ({
  isCurrency = true,
  pricingDisplayRef
}: PriceTotalMobileProps) => {
  const [formattedPrice] = useTotal();
  const [{ selectedBillingCycle }] = useGlobalStore();
  const [isIntersecting, setIsIntersecting] = useState(false);

  const totalPriceRef = useRef<HTMLDivElement>(null);
  const { estimatedMonthlyCostLabel, estimatedAnnulaCostLabel } =
    useModuleProps();

  const intersectionObserverCallback = (
    entries: IntersectionObserverEntry[]
  ) => {
    const [entry] = entries;
    setIsIntersecting(entry?.isIntersecting || false);
  };

  const handleClickOfTotalPriceInMobile = () => {
    const element = document.getElementById('pricing-display');
    element?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  useEffect(() => {
    // Adding an event listener since it is an absolute element
    const el = totalPriceRef.current;
    if (el) {
      el.addEventListener('click', handleClickOfTotalPriceInMobile);
    }

    // Intersection observer to know if an element is intersecting to viewport
    const observer = new IntersectionObserver(intersectionObserverCallback, {
      threshold: 0.4
    });

    if (pricingDisplayRef.current) {
      observer.observe(pricingDisplayRef.current);
    }

    return () => {
      if (el) {
        el.removeEventListener('click', handleClickOfTotalPriceInMobile);
      }

      if (pricingDisplayRef.current) {
        observer.unobserve(pricingDisplayRef.current);
      }
    };
  });

  return (
    !isIntersecting && (
      <div css={containerStyles}>
        <div css={wrapperStyles} ref={totalPriceRef}>
          <div css={priceTotalStyles}>
            <div css={totalStyles}>{formattedPrice}</div>
            <div css={currencyStyles} id="Currency for Total Price">
              {isCurrency ? 'USD' : 'JPY'}
            </div>
          </div>
          <div css={estimatedCostStyles} id="estimatedCost">
            {selectedBillingCycle === 'MONTHLY'
              ? estimatedMonthlyCostLabel
              : estimatedAnnulaCostLabel}
          </div>
          <div css={iconStyles}>
            <svg
              width="13"
              height="7"
              viewBox="0 0 13 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2813 1.27933L7.03201 6.52857C6.88351 6.67932 6.69076 6.75207 6.49801 6.75207C6.30526 6.75207 6.11251 6.67932 5.96626 6.53382C5.96551 6.53157 0.717012 1.28157 0.717012 1.28157C0.424512 0.989825 0.424512 0.512824 0.717012 0.221075C1.00801 -0.0706754 1.48576 -0.0706754 1.77751 0.221075L5.74801 4.19157L6.49857 4.8839L7.24726 4.19157L11.2208 0.218825C11.5125 -0.0729251 11.9895 -0.0729251 12.2813 0.218825C12.4268 0.365075 12.4995 0.557075 12.4995 0.749825C12.4995 0.941825 12.4268 1.13458 12.2813 1.27933Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    )
  );
};

export default PriceTotalMobile;
